module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', _vm._g({
    directives: [{
      name: "ripple",
      rawName: "v-ripple"
    }],
    class: _vm.containerClass,
    attrs: {
      "type": "button"
    }
  }, _vm.$listeners), [_c('span', {
    staticClass: "p-paginator-icon pi pi-angle-right"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7250d58c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/primevue/paginator/NextPageLink.vue
// module id = 2310
// module chunks = 0